// extracted by mini-css-extract-plugin
export default {"paper":"CheckoutMessageCard_paper__BUPXr","leftPaper":"CheckoutMessageCard_leftPaper__oRrKx"};